// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VM4caK73EFS1un {
  width: 321px;
  margin-bottom: var(--ds-space-200, 16px);
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: var(--ds-border-radius-100, 3px);
}
.VM4caK73EFS1un .lmo0t0KerA0GQC {
  height: max-content;
  padding: var(--ds-space-150, 10px) var(--ds-space-200, 16px);
  border: 1px solid var(--ds-border, #091e4224);
  background-color: var(--ds-surface, #ffffff);
}
.VM4caK73EFS1un .lmo0t0KerA0GQC .v3S7KjNRbBaL1x,
.VM4caK73EFS1un .lmo0t0KerA0GQC .YKUcm5paZEfFn9 {
  display: inline;
  margin-right: var(--ds-space-075, 5px);
  margin-left: var(--ds-space-150, 10px);
  font-weight: var(--ds-font-weight-bold, bold);
  vertical-align: text-bottom;
}
.VM4caK73EFS1un .lmo0t0KerA0GQC .v3S7KjNRbBaL1x {
  border-bottom: 1px dashed var(--ds-text-subtlest, #626f86);
  cursor: pointer;
}
.VM4caK73EFS1un .XhoxPg2tNJHnSM {
  display: flex;
  justify-content: space-between;
  padding: var(--ds-space-150, 10px) var(--ds-space-200, 16px);
  border: 1px solid var(--ds-border, #091e4224);
}
@media only screen and (max-width: 450px) {
  .VM4caK73EFS1un {
    width: 265px;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `VM4caK73EFS1un`,
	"feature": `lmo0t0KerA0GQC`,
	"featureName": `v3S7KjNRbBaL1x`,
	"featureNameNoTooltip": `YKUcm5paZEfFn9`,
	"plan": `XhoxPg2tNJHnSM`
};
export default ___CSS_LOADER_EXPORT___;
